import store from '@/store';
import { accuitySupplementaryRepository } from '@/forms/api/repository-factory';
import callApi from '@/lib/helpers/call-api';
import { SET_ACCUITY_RESPONSE } from '@/lib/constants/mutations';
const accuityDateFormat = function(date) {
    var datetoConvert = new Date(date);
    var dobDate = datetoConvert.getDate();
    var dobMonth = datetoConvert.getMonth() + 1;
    var dobYear = datetoConvert.getFullYear();
    let month = '';
    var newdobDate = dobDate < 10 ? '0' + '' + dobDate + '' : '' + dobDate + '';
    let newdobMonth = dobMonth < 10 ? '0' + '' + dobMonth + '' : '' + dobMonth + '';
    return newdobMonth + '.' + newdobDate + '.' + '' + dobYear + '';
};


export default {
    async accuitySupplementary(currentStep, reqObject, callbacks) {
        const { form } = currentStep;
        const { cifnumber } = store.state;
        let uniqueId = cifnumber + reqObject['passportID'].substr(reqObject['passportID'].length - 4);
        let response = false;
        response = await callApi({
            callbacks,
            form,
            formElement: currentStep,
            apiCall: accuitySupplementaryRepository.accuitySupplementary,
            payload: {
                "ApiName": "importScreeningService",
                "ClientEntityType": "Individual",
                "DomicileCountry": "UAE",
                "uniqueId": uniqueId,
                "ClientFullName": reqObject['firstName'] + " " + reqObject['lastName'],
                "DateOfBirth": accuityDateFormat(reqObject['dateOfBirth']),
                "Nationality": reqObject['nationality'],
                "PassportOrIdNo": reqObject['passportID']
            },
        });
        if (response) {
            const accuityResponse = response;
            store.commit(SET_ACCUITY_RESPONSE, { accuityResponse });
        }
    }
};